import LeftSide from './LeftSide';

export default LeftSide;
